import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PermissionEnum, TransactionLogsContent } from '@ui/src';
import { useAppSelector } from '@store';
import useProblemOutgoingTransaction from '../hooks/use-outgoing';

const ProblemOutgoingTransactionLogContentHOC = (): React.JSX.Element => {
  const { transactionId } = useParams();

  const { logs } = useAppSelector(
    (state) => state.customersProblemTransactions.outgoing,
  );
  const { activePermissions } = useAppSelector((state) => state.root);

  const { isLoadingLog, getOutgoingLogsAction } = useProblemOutgoingTransaction(
    {
      transactionId,
    },
  );

  useEffect(() => {
    if (!logs && transactionId) {
      getOutgoingLogsAction();
    }
  }, [getOutgoingLogsAction, logs, transactionId]);

  return (
    <TransactionLogsContent
      isLoading={isLoadingLog}
      logs={logs}
      activePermission={activePermissions?.includes(
        PermissionEnum.TRANSACTION_QUEUE_ITEMS_OUTGOING_LIST,
      )}
    />
  );
};

export default ProblemOutgoingTransactionLogContentHOC;
